import { Injectable } from '@angular/core';
import { StorageService } from '@app/services/storage.service';
import {
  ActionPerformed,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { UpcomingDetailsPageComponent } from '@app/pages/upcoming-details/upcoming-details.page';

@Injectable({
  providedIn: 'root'
})
export class FCMService {
  isDevice;
  constructor(
      private storageService: StorageService,
      private platform: Platform,
      private router: Router,
      private modalController: ModalController
    ) {
      this.isDevice = this.platform.is('cordova');
    }

  async initializeFCM() {
    await PushNotifications.removeAllListeners();

    PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        PushNotifications.register();
      }
    });

    PushNotifications.addListener('registration', (token: Token) => {
      this.storageService.fcmToken.next(token.value);
    });
    
    PushNotifications.addListener('registrationError', (error: any) => {
      console.log(error);
    });

    PushNotifications.addListener('pushNotificationActionPerformed', async (notification: ActionPerformed) => {
      let { upcomings, changeType} = notification.notification.data;
      if (upcomings) {
        upcomings = JSON.parse(upcomings);
      }
      // if payload data has no upcoming navigate user to upcoming page
      const openedModal = await this.modalController.getTop();
      if (openedModal) {
        openedModal.dismiss();
      }
      if (changeType === 'Room Changed') {
        await this.router.navigate(['tabs/tab-home']);
      } else if (changeType === 'Manage Booking') {
        await this.router.navigate(['tabs/tab-manage']);
      } else if (upcomings) {
        // open model with detail changed upcoming
        const modal = await this.modalController.create({
          component: UpcomingDetailsPageComponent,
          canDismiss: true,
          componentProps: {
            upcoming: upcomings
          }
        });
        modal.present();
      } else {
        await this.router.navigate(['tabs/tab-upcoming']);
      } 
    });
  }

  async disablePushNotification() {
    await PushNotifications.unregister();
    await PushNotifications.removeAllListeners();
  }
}
